import cx from 'classnames'
import type { CSSProperties } from 'react'

import { paperStyles } from '../../libs/paperStyles'

type Props = {
  step: number
  total: number
}

export const ProgressBar = ({ step, total }: Props) => {
  const completionPercent = (step / total) * 100

  return (
    <div
      className={`w-full h-2 rounded-lg relative ${paperStyles({ isFaded: true })}`}
      style={{ '--progress-pct': `${completionPercent}%` } as CSSProperties}
    >
      <div
        className={cx(
          'w-(--progress-pct) h-full rounded-lg transition-all duration-500',
          step < total ? 'bg-primary-600' : 'bg-success-600',
        )}
      />
    </div>
  )
}
